import React from 'react';

const DailyEvaluationContainer: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  return <>{'Daily'}</>;
};

export { DailyEvaluationContainer };
